import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';

const today = () => {
    const date = new Date();
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

export default function UserSubscriptionModal({user, onClose, onSaved}) {
    const t = useSelector(state => state.language.translator);
    const dialog = useRef(null);
    const saving = useRef(false);
    const [subscriptionDate, setDate] = useState(today);
    const [subscriptionSum, setSum] = useState('');
    const [pending, setPending] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const element = dialog.current;
        element.showModal();
        return () => element.close();
    }, []);

    const save = async event => {
        event.preventDefault();
        if (saving.current) return;
        if (!subscriptionSum.trim() || subscriptionSum.length > 100 || !subscriptionDate) {
            setError(t.gettext('Enter a date and a non-empty subscription sum (up to 100 characters).'));
            return;
        }
        saving.current = true;
        setPending(true);
        setError('');
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/custom/users/${user.id}/subscriptions`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json', Authorization: sessionStorage.getItem('agronetToken'),
                    Local: localStorage.getItem('lang') || 'en'},
                body: JSON.stringify({subscriptionDate, subscriptionSum: subscriptionSum.trim()})
            });
            if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
            onSaved();
        } catch (err) {
            setError(`${t.gettext('Unable to save subscription')}: ${err.message}`);
        } finally {
            saving.current = false;
            setPending(false);
        }
    };

    return <dialog ref={dialog} className="agronetProCompanyDetails subscriptionModal" aria-labelledby="subscriptionTitle"
        onCancel={event => {event.preventDefault(); if (!saving.current) onClose();}}>
        <div className="companyDetailsHeader">
            <h2 id="subscriptionTitle">{t.gettext('Add subscription')}</h2>
            <button type="button" disabled={pending} onClick={onClose}>{t.gettext('Close')}</button>
        </div>
        <p>{user.name} — {user.email}</p>
        <form onSubmit={save}>
            <fieldset disabled={pending}>
                <div className="companyDetailsFields">
                    <label>{t.gettext('Subscription date')}<input type="date" required value={subscriptionDate}
                        onChange={event => setDate(event.target.value)} autoFocus /></label>
                    <label>{t.gettext('Subscription sum')}<input type="text" required maxLength={100} value={subscriptionSum}
                        onChange={event => setSum(event.target.value)} /></label>
                </div>
            </fieldset>
            {error && <p role="alert">{error}</p>}
            <button type="submit" disabled={pending}>{t.gettext(pending ? 'Saving' : 'Save')}</button>
        </form>
    </dialog>;
}
